module.exports = __webpack_public_path__ + "img/wheel_LOW_lose.e998ce81.png";